const states = [
  { 'state': 'Alabama', 'fips': '01', 'st' : 'AL' },
  { 'state': 'Alaska', 'fips': '02', 'st' : 'AK' },
  { 'state': 'Arizona', 'fips': '04', 'st' : 'AZ' },
  { 'state': 'Arkansas', 'fips': '05', 'st' : 'AR' },
  { 'state': 'California', 'fips': '06', 'st' : 'CA' },
  { 'state': 'Colorado', 'fips': '08', 'st' : 'CO' },
  { 'state': 'Connecticut', 'fips': '09', 'st' : 'CT' },
  { 'state': 'Delaware', 'fips': '10', 'st' : 'DE' },
  { 'state': 'District of Columbia', 'fips': '11', 'st' : 'DC' },
  { 'state': 'Florida', 'fips': '12', 'st' : 'FL' },
  { 'state': 'Georgia', 'fips': '13', 'st' : 'GA' },
  { 'state': 'Hawaii', 'fips': '15', 'st' : 'HI' },
  { 'state': 'Idaho', 'fips': '16', 'st' : 'ID' },
  { 'state': 'Illinois', 'fips': '17', 'st' : 'IL' },
  { 'state': 'Indiana', 'fips': '18', 'st' : 'IN' },
  { 'state': 'Iowa', 'fips': '19', 'st' : 'IA' },
  { 'state': 'Kansas', 'fips': '20', 'st' : 'KS' },
  { 'state': 'Kentucky', 'fips': '21', 'st' : 'KY' },
  { 'state': 'Louisiana', 'fips': '22', 'st' : 'LA' },
  { 'state': 'Maine', 'fips': '23', 'st' : 'ME' },
  { 'state': 'Maryland', 'fips': '24', 'st' : 'MD' },
  { 'state': 'Massachusetts', 'fips': '25', 'st' : 'MA' },
  { 'state': 'Michigan', 'fips': '26', 'st' : 'MI' },
  { 'state': 'Minnesota', 'fips': '27', 'st' : 'MN' },
  { 'state': 'Mississippi', 'fips': '28', 'st' : 'MS' },
  { 'state': 'Missouri', 'fips': '29', 'st' : 'MO' },
  { 'state': 'Montana', 'fips': '30', 'st' : 'MT' },
  { 'state': 'Nebraska', 'fips': '31', 'st' : 'NE' },
  { 'state': 'Nevada', 'fips': '32', 'st' : 'NV' },
  { 'state': 'New Hampshire', 'fips': '33', 'st' : 'NH' },
  { 'state': 'New Jersey', 'fips': '34', 'st' : 'NJ' },
  { 'state': 'New Mexico', 'fips': '35', 'st' : 'NM' },
  { 'state': 'New York', 'fips': '36', 'st' : 'NY' },
  { 'state': 'North Carolina', 'fips': '37', 'st' : 'NC' },
  { 'state': 'North Dakota', 'fips': '38', 'st' : 'ND' },
  { 'state': 'Ohio', 'fips': '39', 'st' : 'OH' },
  { 'state': 'Oklahoma', 'fips': '40', 'st' : 'OK' },
  { 'state': 'Oregon', 'fips': '41', 'st' : 'OR' },
  { 'state': 'Pennsylvania', 'fips': '42', 'st' : 'PA' },
  { 'state': 'Rhode Island', 'fips': '44', 'st' : 'RI' },
  { 'state': 'South Carolina', 'fips': '45', 'st' : 'SC' },
  { 'state': 'South Dakota', 'fips': '46', 'st' : 'SD' },
  { 'state': 'Tennessee', 'fips': '47', 'st' : 'TN' },
  { 'state': 'Texas', 'fips': '48', 'st' : 'TX' },
  { 'state': 'Utah', 'fips': '49', 'st' : 'UT' },
  { 'state': 'Vermont', 'fips': '50', 'st' : 'VT' },
  { 'state': 'Virginia', 'fips': '51', 'st' : 'VA' },
  { 'state': 'Washington', 'fips': '53', 'st' : 'WA' },
  { 'state': 'West Virginia', 'fips': '54', 'st' : 'WV' },
  { 'state': 'Wisconsin', 'fips': '55', 'st' : 'WI' },
  { 'state': 'Wyoming', 'fips': '56', 'st' : 'WY' },
  { 'state': 'American Samoa', 'fips': '60', 'st' : 'AS' },
  { 'state': 'Guam', 'fips': '66', 'st' : 'GU' },
  { 'state': 'Micronesia', 'fips': '69', 'st' : 'MP' },
  { 'state': 'Puerto Rico', 'fips': '72', 'st' : 'PR' },
  { 'state': 'U.S. Virgin Islands', 'fips': '78', 'st' : 'VI' } 
]

export default states